import { InjectionToken } from '@angular/core';

import type { User } from '@core/account-types';

export type ShareOnTheGoDialogData = {
  talentPoolId?: number;
  offerId?: number;
  candidateId: number;
  usersToShareWith: User[];
  disableSubmitOnSkipAll: boolean;
} | null;

export interface UserAccessValue {
  user: User;
  accessValue: AccessValue;
}

export interface ShareOnTheGoDialogResult {
  userAccessValues: UserAccessValue[];
}

export enum AccessValue {
  CandidateOnly = 'candidate_only',
  AllCandidatesInOffer = 'all_candidates_in_offer',
  DontRequest = 'dont_request',
}

interface AccessOptionConfigItem {
  isEnabled: boolean;
  isVisible: boolean;
}

export type AccessOptionsConfig = {
  [key in AccessValue]: AccessOptionConfigItem;
};

export interface ShareOnTheGoI18n {
  submitBtn: string;
  dontRequestOption: string;
  dontRequestOptionTooltip: string;
}

export const SHARE_ON_THE_GO_I18N: InjectionToken<ShareOnTheGoI18n> =
  new InjectionToken<ShareOnTheGoI18n>('SHARE_ON_THE_GO_I18N');
